import { createTheme, Theme, ThemeOptions } from '@mui/material'

export function getAppTheme (darkMode?: boolean): Theme {
  const lightTheme = {
    palette: {
      primary: {
        dark: '#800000',
        main: '#FF3939',
      },
      secondary: {
        main: '#333333',
        dark: '#151515',
        light: '#9A9A9A',
      },
    },
    typography: {
      fontSize: 12,
    },
    overrides: {
      MuiAutocomplete: {
        option: {
          '&[data-focus="true"]': {
            color: '#FF3939',
          },
        },
      },
      MuiOutlinedInput: {
        root: {
          '&:hover:not($disabled):not($focused):not($error) $notchedOutline': {
            border: '2px solid',
            borderColor: '#FF3939',
          },
          '&$focused $notchedOutline': {
            borderColor: '#FF3939',
            borderWidth: 1,
          },
        },
      },
      MuiTabs: {
        root: {
          backgroundColor: '#f5f5f5',
          borderTop: '2px solid',
          borderColor: '#ebe7e9',
        },
      },
      MuiTab: {
        root: {
          '&$selected': {
            backgroundColor: '#ffffff',
            borderTop: '3px solid',
            borderColor: '#FF3939',
            color: '#FF3939',
          },
        },
      },
      MuiButton: {
        root: {
          border: '1px solid #B72841',
          color: '#ffffff',
          backgroundColor: '#FF3939',
          minWidth: '0',
          boxShadow: 'none',
        },
        containedSecondary: {
          backgroundColor: '#ffffff',
          border: '1px solid #FF3939',
          color: '#FF3939',
          '&:hover': {
            backgroundColor: '#ffffff',
            border: '1px solid #FF3939',
            color: '#800000',
          },
        },
        containedPrimary: {
          color: '#ffffff',
          backgroundColor: '#FF3939',
          border: '1px solid #FF3939',
          '&:hover': {
            backgroundColor: '#ffffff',
            color: '1px solid #FF3939',
          },
        },
      },
      MuiPickersToolbarButton: {
        toolbarBtn: {
          border: 'none',
          '&:hover': {
            backgroundColor: 'transparent',
            border: 'none',
          },
        },
      },
      MuiPickersToolbarText: {
        toolbarTxt: {
          '&:hover': {
            color: '#FF3939',
          },
        },
      },
    },
  }

  const darkTheme: ThemeOptions = {
    typography: {
      fontSize: 12,
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            border: '1px solid #FF3939',
            minWidth: '0',
            boxShadow: 'none',
          },
          text: {
            color: '#FF3939',
          },
        },
      },
    },
    palette: {
      mode: 'dark',
      primary: {
        main: '#FF3939',
        light: 'rgba(255, 255, 255, 0.5)',
        dark: '#121212',
      },
      grey: {
        A100: 'transparent',
        A200: 'rgba(255, 255, 255, 0.08)',
      },
      secondary: {
        main: '#FF3939',
      },
      background: {
        default: '#121212',
        paper: '#39465c',
      },
      text: {
        primary: 'rgba(255, 255, 255, 0.5)',
        secondary: 'rgba(255, 255, 255, 0.3)',
      },
    },
  }

  const theme: Theme = createTheme(darkMode ? darkTheme : lightTheme)

  return theme
}
